import { render, staticRenderFns } from "./FilterTable.vue?vue&type=template&id=ede1860a&scoped=true&"
import script from "./FilterTable.vue?vue&type=script&lang=js&"
export * from "./FilterTable.vue?vue&type=script&lang=js&"
import style0 from "./FilterTable.vue?vue&type=style&index=0&id=ede1860a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede1860a",
  null
  
)

export default component.exports